/* ==========================================================================
   PAMPER & PIECE — wishlist.js  ("Add to wardrobe")
   Source of truth is localStorage for instant, logged-out-friendly UX.
   When a customer is logged in we mirror the wardrobe to a customer metafield
   (pamper.wardrobe, list.product_reference) via an app proxy that calls the
   Customer Account API server-side — storefront JS cannot write customer
   metafields directly. The proxy call is best-effort; the UI never blocks on it.
   ========================================================================== */
(function () {
  'use strict';
  const Pamper = (window.Pamper = window.Pamper || {});
  const KEY = 'pp:wardrobe';

  /* ---------- storage ---------- */
  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateCount(list.length);
    syncToCustomer(list);
  }
  function has(handle) {
    return read().some((i) => i.handle === handle);
  }

  /* ---------- best-effort server sync (logged-in customers) ---------- */
  let syncTimer;
  function syncToCustomer(list) {
    if (!Pamper.settings || !Pamper.settings.customerLoggedIn) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(() => {
      // App proxy endpoint -> server uses Customer Account API to set
      // customer metafield pamper.wardrobe. Safe no-op if the proxy is absent.
      fetch('/apps/wardrobe/sync', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handles: list.map((i) => i.handle) }),
      }).catch(() => {});
    }, 800);
  }

  /* ---------- UI ---------- */
  function updateCount(n) {
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function paintButton(btn, active) {
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    const label = active
      ? (Pamper.strings && Pamper.strings.inWardrobe) || 'In your wardrobe'
      : btn.dataset.labelDefault || btn.getAttribute('aria-label');
    if (active && !btn.dataset.labelDefault) btn.dataset.labelDefault = btn.getAttribute('aria-label');
    btn.setAttribute('aria-label', label);
    // Swap heart outline <-> fill if the markup provides both.
    const icon = btn.querySelector('svg');
    if (icon) icon.style.fill = active ? 'currentColor' : 'none';
  }

  function toggle(btn) {
    const handle = btn.dataset.productHandle;
    const id = btn.dataset.productId;
    if (!handle) return;
    const list = read();
    const idx = list.findIndex((i) => i.handle === handle);
    let active;
    if (idx > -1) {
      list.splice(idx, 1);
      active = false;
      Pamper.toast && Pamper.toast((Pamper.strings && Pamper.strings.removedFromWardrobe) || 'Removed');
    } else {
      list.push({ handle, id, addedAt: Date.now() });
      active = true;
      Pamper.toast && Pamper.toast((Pamper.strings && Pamper.strings.addedToWardrobe) || 'Saved 💖');
    }
    write(list);
    // Repaint every button for this product (card + PDP can coexist).
    document
      .querySelectorAll(`[data-wishlist-toggle][data-product-handle="${handle}"]`)
      .forEach((b) => paintButton(b, active));
  }

  /* ---------- init ---------- */
  function hydrate() {
    const list = read();
    updateCount(list.length);
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      paintButton(btn, has(btn.dataset.productHandle));
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault();
      toggle(btn);
    }
  });

  // Expose for the wardrobe page to render saved scents.
  Pamper.wardrobe = { read, has, toggle };

  hydrate();
})();
